import Api from "@config/axios"

function getSettings() {
  return Api.get('system/settings')
}

export default {
  getSettings
}